import React,{ useEffect, useState,useImperativeHandle,forwardRef } from 'react';
import styles from './styles.scss';
import Error from '@/components/Error';
import { history } from 'umi';
import { getProgramVideos,subscriptionProgram,collectProgram,likeProgram,shareProgram } from '@/services/program';
import {Toast} from 'antd-mobile';


export default forwardRef((props,ref) => {

  const {program, onDirClick,selectId, onDirSelect,goComment} = props;

  const [dirList, setDirList] = useState([]);
  const [error, setError] = useState(null);

  const [selectDir, setSelectDir] = useState(null);

  const [isLike,setIsLike] = useState(program.isLike);
  const [isCollect,setIsCollect] = useState(program.isCollect);
  const [isSubscription,setIsSubscription] = useState(program.isSubscription);


// 关键代码
  useImperativeHandle(ref, () => ({
    defaultPlay: () => {
      if (!selectDir) {
        if (dirList.length > 0) {
          let dir = dirList[0];
          setSelectDir(dir);
          onDirClick && onDirClick(dir);
        }
      } else {
        onDirClick && onDirClick(selectDir);
      }

    }
  }));

  useEffect(()=>{
    getDir();
  },[]);

  function getDir() {
    getProgramVideos({columnId:program.id,pageNo:1,pageSize:1000}).then(res => {
      console.log(res);

      if (res && res.code == 200) {
        setError(null);
        setDirList(res.data.list);
        for (let i=0; i < res.data.list.length; i++) {
          if (res.data.list[i].id == selectId) {
            setSelectDir(res.data.list[i]);
            onDirSelect && onDirSelect(res.data.list[i]);
          }
        }
      }else {
        setError('目录加载失败，请重试');
      }
    }).catch(e => {
      setError('目录加载失败，请重试');
    });
  }


  function subscription() {
    subscriptionProgram({ columnId: program.id }).then(res => {

      if (res.code == 200) {
        setIsSubscription(isSubscription == '0' ? '1' : '0');
        Toast.success(res.data, 1);
      } else {
        Toast.fail(res.message, 1);

      }
    }).catch(e => {
      Toast.fail('请求失败，请重试', 1);

    });
  }

  function like() {
    likeProgram({columnId: program.id}).then(res => {

      if (res.code == 200) {
        setIsLike(isLike == '0' ? '1' : '0');
        Toast.success(res.data,1);
      } else {
        Toast.fail(res.message,1);

      }
    }).catch(e => {
      Toast.fail('请求失败，请重试',1);

    });
  }

  function share() {
    updateShareInfo({title:program.name,desc:'',link:program.image,imgUrl:program.image,success:()=>{

      }});
  }

  function collect() {
    collectProgram({columnId: program.id}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setIsCollect(isCollect == '0' ? '1' : '0');
        Toast.success(res.data,1);
      } else {
        Toast.fail(res.message,1);

      }
    }).catch(e => {
      Toast.fail('请求失败，请重试',1);

    });
  }


  return(
    <div className={styles.tabBox}>
      <div style={{display:'flex',flexDirection:'column',overflow:'auto', paddingBottom: '56px'}}>

      {error && <Error error={error} onRefresh={() =>{
        getDir();
      }}/>}

      {!error && dirList.map(item => (
        <div className={selectDir && selectDir.id ==  item.id ? styles.dirItem_on : styles.dirItem} key={item.id}
             onClick={() => {
               setSelectDir(item);
               onDirSelect && onDirSelect(item);
               onDirClick && onDirClick(item);
        }}>

          <label className={styles.dateName}>{item.dateName}</label>
          <label className={styles.dirName}>{item.videoName}</label>

        </div>
      )) }
      </div>


      <div className={styles.bottomBar}>

        <div className={styles.bottomItem} onClick={() =>{
          goComment && goComment();
        }}>
          <img src={require('@/assets/ic_comment.png')}/>
          <label>评论</label>
        </div>

        <div className={styles.bottomItem} onClick={() =>{
          subscription();
        }}>
          <img src={isSubscription == '0' ? require('@/assets/ic_subscribe.png') : require('@/assets/ic_subscribed.png')}/>
          <label style={{color: isSubscription == '0' ? '#555' : '#57B99D'}}>{isSubscription == '0' ? '订阅' : '已订阅'}</label>
        </div>

        <div className={styles.bottomItem} onClick={() =>{
          like();
        }}>
          <img src={isLike == '0' ? require('@/assets/ic_like.png') : require('@/assets/ic_liked.png')}/>
          <label style={{color:isLike == '0' ? '#555' : '#57B99D'}}>{isLike == '0' ? '点赞' : '已赞'}</label>
        </div>

        {/*<div className={styles.bottomItem} onClick={() =>{*/}
          {/*share();*/}
        {/*}}>*/}
          {/*<img src={require('@/assets/ic_share.png')}/>*/}
          {/*<label>分享</label>*/}
        {/*</div>*/}

        <div className={styles.bottomItem} onClick={() =>{
          collect();
        }}>
          <img src={isCollect == '0' ? require('@/assets/ic_collect.png') : require('@/assets/ic_collected.png')}/>
          <label style={{color: isCollect == '0' ? '#555' : '#57B99D'}}>{isCollect == '0' ? '收藏' : '已收藏'}</label>
        </div>
      </div>

    </div>
  )

})


